import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateEstadoPericiaRequest } from '@models/estadoPericia/createEstadoPericiaRequest.model';
import { UpdateEstadoPericiaRequest } from '@models/estadoPericia/updateEstadoPericiaRequest.model';
import { CreateFueroRequest } from '@models/fuero/createFueroRequest.model';
import { UpdateFueroRequest } from '@models/fuero/updateFueroRequest.model';

@Injectable({
  providedIn: 'root'
})
export class FueroService {

  constructor(private http:HttpClient) {
  }

  create(createFueroRequest:CreateFueroRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/Fuero/Create",createFueroRequest);
  }

  update(updateFueroRequest:UpdateFueroRequest):Observable<any>
  {
    return  this.http.put<any>("/api/Fuero/Update",updateFueroRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/Fuero/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/Fuero/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/Fuero/Delete?id=" + id);
    else
      return of(null)
  }

}
